import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withProps, withPropsOnChange, withHandlers, lifecycle } from 'recompose';

import WithShop from '../../../hoc/WithShop';
import { SHOP_TYPE } from '../../../constants';
import withGiftCardAmount from '../../hoc/withGiftCardAmount';
import withGiftCardBarber from '../../hoc/withGiftCardBarber';
import { updateGcAmount, updateSelectedBarber } from '../../actions';
import WithGiftCardUrlPattern from '../../../hoc/WithGiftCardUrlPattern';
import { getBarberByRoute, getBarbers, getAllBarbersRaw } from '../../../barbers/selectors';
import withAreGcSalesDisabledForBarber
  from '../../hoc/withAreGcSalesDisabledForBarber';

const anyBarber = {
  id: null,
  firstName: 'Any',
  lastName: 'Professional',
  route: 'any',
};

const withBarbersProps = withProps((props) => {
  if (!props.shop) return {};

  let barbers = props.barbers;
  if (props.shop.kind === SHOP_TYPE.commission) {
    barbers = [anyBarber, ...props.barbers];
  }

  return {
    barbers,
    barber: props.barber ? props.barber.toJS() : null,
  };
});

export default compose(
  withRouter,
  WithGiftCardUrlPattern,
  withGiftCardAmount,
  withGiftCardBarber,
  WithShop,
  withAreGcSalesDisabledForBarber,
  connect(
    (state, ownProps) => ({
      barber: getBarberByRoute(state, ownProps.params.barberRoute),
      barbers: ownProps.location.query.brand ? getAllBarbersRaw(state) : getBarbers(state, ownProps.params),
    }),
    {
      updateGcAmount,
      updateSelectedBarber,
    }
  ),
  withBarbersProps,
  withProps(props => ({
    isCommissionShop: props.shop && props.shop.kind === SHOP_TYPE.commission,
  })),
  withHandlers({
    onGcAmountChange: props => (amount) => {
      props.updateGcAmount(Number(amount));
    },
    onSelectedBarberChange: props => (barber) => {
      props.updateSelectedBarber(barber);
    },
  }),
  withPropsOnChange(
    ['shop'],
    (props) => {
      if (props.isCommissionShop && !props.gcBarber) {
        props.onSelectedBarberChange(anyBarber);
      }
    }
  ),
  lifecycle({
    componentDidMount() {
      const gcAmount = Number(this.props.params.giftCardAmount);
      if (gcAmount) {
        this.props.updateGcAmount(gcAmount);
      }

      if (this.props.barber) {
        this.props.onSelectedBarberChange(this.props.barber);
      }
    },
  }),
);



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCard/GiftCardContainer.js